exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".inputW_6e6cbc0{width:500px!important}.tableW_7663d7b{width:100%}.widthAuto_42385c6{width:-webkit-fill-available}", ""]);

// exports
exports.locals = {
	"inputW": "inputW_6e6cbc0",
	"tableW": "tableW_7663d7b",
	"widthAuto": "widthAuto_42385c6"
};